/* eslint-disable consistent-return,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es';
import SweetAlert from 'react-bootstrap-sweetalert';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import ArrowUp from '@material-ui/icons/ArrowUpward';
import SupervisedUser from '@material-ui/icons/SupervisedUserCircle';
import Clear from '@material-ui/icons/Close';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
import CustomInput from 'components/UI/CustomInput/CustomInput';
// our components
import { paymentStatus, orderTypes, paymentTypes } from 'config';
import Datepicker from 'components/common/DatePicker';
import SectionDivider from 'components/common/SectionDivider/SectionDivider';
import UserSelect from 'components/User/Select';
import User from '@material-ui/icons/AccountCircle';

/**
 * Variable to define default selected status
 */
const defaultSelectedStatus = [
  paymentStatus.PENDING,
  paymentStatus.PAYED,
  paymentStatus.CANCELLED,
  paymentStatus.FAILED,
  paymentStatus.REFUNDED,
  paymentStatus.PENDING_REFUND,
  paymentStatus.FAILED_REFUND,
];
const defaultSelectedOrderTypes = [orderTypes.CREDIT, orderTypes.PAIDAD];
const defaultSelectedTypes = [paymentTypes.MOLLIE, paymentTypes.COINBASE];

/**
 * @class
 * @extends React.Component
 */
class PaymentFilter extends React.Component {
  constructor(props) {
    super(props);
    const { appliedFilters } = props;
    this.state = {
      selectedPaymentStatus:
        (appliedFilters && appliedFilters.status) || defaultSelectedStatus,
      selectedOrderTypes:
        (appliedFilters && appliedFilters.orderType) ||
        defaultSelectedOrderTypes,
      selectedTypes:
        (appliedFilters && appliedFilters.type) || defaultSelectedTypes,
      localFilter: appliedFilters || null,
      showSelectAgency: false,
      showSelectUser: false,
    };
  }

  /**
   * @description
   * Change filters.
   *
   * @param {Object} changedFilter - Changed filters values.
   */
  changeLocalFilter = changedFilter => {
    const { localFilter } = this.state;
    this.setState({ localFilter: { ...localFilter, ...changedFilter } });
  };

  /**
   * @description
   * Handle select status/orderTypes checkboxes.
   *
   * @param {string} checkLabel - Status/OrderTypes selected.
   * @param {string} selectedState - Status/OrderTypes local state name.
   * @param {string} filterName - Status/OrderTypes filter name.
   * @returns {undefined} No return.
   */
  handleCheck = (checkLabel, selectedState, filterName) => {
    // eslint-disable-next-line react/destructuring-assignment
    const state = this.state[selectedState];
    let finalState = [];

    // if exists, remove from list
    if (state.indexOf(checkLabel) !== -1) {
      finalState = state.filter(label => label !== checkLabel);
      // in database, there's payments with PARTIAL_REFUNDED
      // and TOTAL_REFUNDED as status, we need to add/remove those
      // if the status is REFUNDED
      if (checkLabel === paymentStatus.REFUNDED) {
        finalState = finalState.filter(
          label =>
            label !== paymentStatus.PARTIAL_REFUNDED &&
            label !== paymentStatus.TOTAL_REFUNDED,
        );
      }
    } else {
      // otherwise, add it
      finalState = [...state, checkLabel];
      if (checkLabel === paymentStatus.REFUNDED) {
        finalState = [
          ...finalState,
          paymentStatus.PARTIAL_REFUNDED,
          paymentStatus.TOTAL_REFUNDED,
        ];
      }
    }

    this.setState({ [selectedState]: finalState }, () =>
      this.changeLocalFilter(
        finalState.length === 0
          ? { [filterName]: undefined }
          : { [filterName]: finalState },
      ),
    );
  };

  /**
   * @description
   * Call filter callback.
   */
  handleFilter = () => {
    const { onFilter } = this.props;
    const { localFilter } = this.state;
    onFilter({ ...localFilter });
  };

  /**
   * @description
   * Render full filter's box.
   * @returns {*} - AdFilter's box.
   */
  render() {
    const { classes, onRestartFilters, t, onShowFilters } = this.props;
    const {
      selectedPaymentStatus,
      selectedOrderTypes,
      localFilter,
      showSelectAgency,
      showSelectUser,
      selectedTypes,
    } = this.state;

    return (
      <div className={classes.expandFilters} style={{ marginBottom: 20 }}>
        <GridContainer>
          <GridItem xs={12} md={6}>
            <SectionDivider label={t('payment.list.filters.section_id.title')}>
              <div style={{ padding: 10 }}>
                <GridContainer>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      id="id"
                      formControlProps={{
                        className: `${classes.top} ${classes.search}`,
                      }}
                      inputProps={{
                        placeholder: t('payment.list.filters.section_id.db_id'),
                        inputProps: {
                          'aria-label': 'Search',
                          className: classes.searchInput,
                        },
                        onChange: e => {
                          const { value } = e.target;
                          this.changeLocalFilter({
                            id: value || undefined,
                          });
                        },
                        value:
                          localFilter.id !== undefined ? localFilter.id : '',
                        type: 'number',
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      id="externalId"
                      formControlProps={{
                        className: `${classes.top} ${classes.search}`,
                      }}
                      inputProps={{
                        placeholder: t(
                          'payment.list.filters.section_id.external_id',
                        ),
                        inputProps: {
                          'aria-label': 'Search',
                          className: classes.searchInput,
                        },
                        onChange: e => {
                          const { value } = e.target;
                          this.changeLocalFilter({
                            externalId: value || undefined,
                          });
                        },
                        value:
                          localFilter.externalId !== undefined
                            ? localFilter.externalId
                            : '',
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer alignItems="center">
                  <GridItem xs={12} md={6}>
                    <div
                      className={`${classes.userSelect} ${
                        localFilter.agency ? classes.userSelected : ''
                      }`}
                    >
                      <Button
                        simple
                        color="info"
                        onClick={() => {
                          this.setState({
                            showSelectAgency: !showSelectAgency,
                          });
                        }}
                      >
                        <div>
                          <p className="title">
                            {t('payment.list.filters.section_id.agency.title')}
                          </p>
                          <p className="user">
                            {localFilter.agencyName
                              ? localFilter.agencyName
                              : t(
                                  'payment.list.filters.section_id.agency.placeholder',
                                )}
                          </p>
                        </div>
                      </Button>

                      {localFilter.agency ? (
                        <Button
                          simple
                          onClick={() => {
                            this.changeLocalFilter({
                              agency: undefined,
                              agencyName: undefined,
                            });
                          }}
                        >
                          <Clear />
                        </Button>
                      ) : (
                        <span>
                          <SupervisedUser />
                        </span>
                      )}
                    </div>

                    <SweetAlert
                      title=""
                      showConfirm={false}
                      showCancel={false}
                      onConfirm={() => {}}
                      customClass={classes.adModalConfirmation}
                      show={showSelectAgency}
                      closeOnClickOutside
                      onCancel={() =>
                        this.setState({
                          showSelectAgency: !showSelectAgency,
                        })
                      }
                    >
                      <UserSelect
                        listAgencies
                        selectUser={agency => {
                          this.setState({
                            localFilter: {
                              ...localFilter,
                              agency: agency.id,
                              agencyName: agency.fullname,
                            },
                            showSelectAgency: !showSelectAgency,
                          });
                        }}
                      />
                    </SweetAlert>
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <div
                      className={`${classes.userSelect} ${
                        localFilter.user ? classes.userSelected : ''
                      }`}
                    >
                      <Button
                        simple
                        color="info"
                        onClick={() => {
                          this.setState({
                            showSelectUser: !showSelectUser,
                          });
                        }}
                      >
                        <div>
                          <p className="title">
                            {t('payment.list.filters.section_id.user.title')}
                          </p>
                          <p className="user">
                            {localFilter.userName
                              ? localFilter.userName
                              : t(
                                  'payment.list.filters.section_id.user.placeholder',
                                )}
                          </p>
                        </div>
                      </Button>

                      {localFilter.user ? (
                        <Button
                          simple
                          onClick={() => {
                            this.changeLocalFilter({
                              user: undefined,
                              userName: undefined,
                            });
                          }}
                        >
                          <Clear />
                        </Button>
                      ) : (
                        <span>
                          <User />
                        </span>
                      )}
                    </div>
                    <SweetAlert
                      title=""
                      showConfirm={false}
                      showCancel={false}
                      onConfirm={() => {}}
                      customClass={classes.adModalConfirmation}
                      show={showSelectUser}
                      closeOnClickOutside
                      onCancel={() =>
                        this.setState({
                          showSelectUser: !showSelectUser,
                        })
                      }
                    >
                      <UserSelect
                        selectUser={user => {
                          this.setState({
                            localFilter: {
                              ...localFilter,
                              user: user.id,
                              userName: user.fullname,
                            },
                            showSelectUser: !showSelectUser,
                          });
                        }}
                      />
                    </SweetAlert>
                  </GridItem>
                </GridContainer>
              </div>
            </SectionDivider>
            <SectionDivider label={t('payment.list.filters.date')}>
              <div style={{ padding: 10 }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Datepicker
                      title={t('paidad.filters.date.from')}
                      defaultValue={t('paidad.filters.date.from_placeholder')}
                      onChange={date => {
                        if (localFilter.startDateLte < date) {
                          return;
                        }
                        this.changeLocalFilter({
                          startDateGte: date
                            ? moment(date)
                                .startOf('day')
                                .format()
                            : undefined,
                        });
                      }}
                      value={
                        localFilter.startDateGte !== undefined
                          ? moment(localFilter.startDateGte)
                          : ''
                      }
                      validGte={localFilter.startDateLte}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Datepicker
                      title={t('paidad.filters.date.to')}
                      defaultValue={t('paidad.filters.date.to_placeholder')}
                      onChange={date => {
                        if (localFilter.startDateGte > date) {
                          return;
                        }
                        this.changeLocalFilter({
                          startDateLte: date
                            ? moment(date)
                                .endOf('day')
                                .format()
                            : undefined,
                        });
                      }}
                      value={
                        localFilter.startDateLte !== undefined
                          ? moment(localFilter.startDateLte)
                          : ''
                      }
                      validLte={localFilter.startDateGte}
                    />
                  </GridItem>
                </GridContainer>
              </div>
            </SectionDivider>
          </GridItem>
          <GridItem xs={12} md={6}>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <SectionDivider label={t('payment.list.filters.product')}>
                  <div
                    style={{
                      padding: 10,
                      height: 80,
                    }}
                  >
                    {Object.keys(orderTypes).map(order => (
                      <FormControlLabel
                        key={order}
                        control={
                          <Checkbox
                            onClick={() =>
                              this.handleCheck(
                                order,
                                'selectedOrderTypes',
                                'orderType',
                              )
                            }
                            checked={selectedOrderTypes.indexOf(order) !== -1}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            className={classes.checked}
                          />
                        }
                        id={order}
                        label={order}
                        style={{ width: '50%' }}
                      />
                    ))}
                  </div>
                </SectionDivider>
              </GridItem>
              <GridItem xs={12} md={6}>
                <SectionDivider label={t('payment.list.filters.type')}>
                  <div
                    style={{
                      padding: 10,
                      height: 80,
                    }}
                  >
                    {Object.keys(paymentTypes).map(type => (
                      <FormControlLabel
                        key={type}
                        control={
                          <Checkbox
                            onClick={() =>
                              this.handleCheck(type, 'selectedTypes', 'type')
                            }
                            checked={selectedTypes.indexOf(type) !== -1}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            className={classes.checked}
                          />
                        }
                        id={type}
                        label={type}
                        style={{ width: '50%' }}
                      />
                    ))}
                  </div>
                </SectionDivider>
              </GridItem>
            </GridContainer>

            <SectionDivider label={t('paidad.filters.section.status')}>
              <div
                style={{
                  padding: 10,
                  maxHeight: 180,
                  display: 'flex',
                  flexDirection: 'column',
                  flexWrap: 'wrap',
                }}
              >
                {defaultSelectedStatus.map(status => (
                  <FormControlLabel
                    key={status}
                    control={
                      <Checkbox
                        onClick={() =>
                          this.handleCheck(
                            status,
                            'selectedPaymentStatus',
                            'status',
                          )
                        }
                        checked={selectedPaymentStatus.indexOf(status) !== -1}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        className={classes.checked}
                      />
                    }
                    id={status}
                    label={t(`payment.list.filters.status.${status}`)}
                    style={{ width: '50%' }}
                  />
                ))}
              </div>

              <GridContainer>
                <GridItem xs={12}>
                  <GridContainer justify="flex-end">
                    <GridItem>
                      <Button
                        color="primary"
                        simple
                        className={classes.buttons}
                        onClick={() =>
                          this.setState(
                            {
                              selectedPaymentStatus:
                                selectedPaymentStatus.length > 0
                                  ? []
                                  : defaultSelectedStatus,
                            },
                            this.updateSelectedCheckboxes,
                          )
                        }
                        id="unselectAll"
                        key="unselectAll"
                      >
                        {selectedPaymentStatus.length > 0
                          ? t('ad.filters.status.uncheck')
                          : t('ad.filters.status.check')}
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </SectionDivider>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Button
              color="primary"
              simple
              className={classes.buttons}
              onClick={onShowFilters}
              id="hideFilters"
              key="hideFilters"
            >
              <ArrowUp />
              {t('ad.filters.shrink')}
            </Button>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <GridContainer justify="flex-end">
              <GridItem>
                <Button
                  color="danger"
                  simple
                  className={classes.buttons}
                  onClick={() => {
                    this.setState({
                      selectedPaymentStatus: defaultSelectedStatus,
                      selectedAgency: undefined,
                      localFilter: {},
                    });
                    onRestartFilters();
                  }}
                  data-testid="restartFilters"
                  key="restartFilters"
                >
                  {t('ad.filters.clean')}
                </Button>
                <Button
                  data-cy="filterAds"
                  color="primary"
                  className={classes.buttons}
                  onClick={() => {
                    this.handleFilter();
                    onShowFilters();
                  }}
                  data-testid="filterAds"
                  key="filterAds"
                >
                  {t('ad.filters.filter')}
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

/**
 * PaymentFilter PropTypes
 * @param classes - styles received from withStyles
 * @param appliedFilters - prop to know applied filters
 * @param t - prop from HOC with string translations
 * @callback onFilter - callback called when user clicks filter button
 * @callback onShowFilters - callback called when user clicks filters button
 * @callback onRestartFilters - callback called when user restart filters button
 */

PaymentFilter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedFilters: PropTypes.shape({}).isRequired,
  onFilter: PropTypes.func.isRequired,
  onShowFilters: PropTypes.func.isRequired,
  onRestartFilters: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(FilterStyles)(PaymentFilter));
